import { uniq } from 'lodash-es';
import { mapState } from 'pinia';
import {
  interactiveModuleTypes,
  TEI_ASSET_SUBTYPES,
} from '@/lib/constants';
import {
  useAssetStore,
  useEditorStore,
} from '@/stores';

export default {
  computed: {
    ...mapState(useEditorStore, [
      'draft',
    ]),
    ...mapState(useAssetStore, [
      'assets',
    ]),
    assetIdsByPage() {
      return this.draft.pages.reduce((acc, page) => {
        const assetIds = (page.modules || [])
          .filter((m) => m.type === 'asset')
          .map((m) => m.options?.asset_id);
        const pageAssetId = page.options?.asset_id;
        if (pageAssetId) assetIds.push(pageAssetId);
        acc[page.id] = assetIds;
        return acc;
      }, {});
    },
    moduleTypesByPage() {
      return this.draft.pages.reduce((acc, page) => {
        acc[page.id] = uniq((page.modules || []).map((m) => m.type));
        return acc;
      }, {});
    },
  },
  methods: {
    pageHasVideo(page) {
      return this.pageHasAssetType(page, 'video');
    },
    pageHasAudio(page) {
      return this.pageHasAssetType(page, 'audio');
    },
    pageHasAssetType(page, assetType) {
      const assetIds = this.assetIdsByPage[page.id];
      return assetIds.some((id) => this.assets[id]?.group === assetType);
    },
    pageHasQuestion(page) {
      const pageModuleTypes = this.moduleTypesByPage[page.id];
      const pageAsset = this.assets[page.options?.asset_id];
      const pageAssetSubtype = pageAsset?.subtype?.name || pageAsset?.sub_type?.name;
      return pageModuleTypes.some((t) => interactiveModuleTypes.includes(t))
        || TEI_ASSET_SUBTYPES.includes(pageAssetSubtype);
    },
  },
};
